import { useFormik } from 'formik';
import { IFormikValues, optionsCategories } from '../types';
import { useWindowSizes } from 'v2/resources/hooks/useWindowSizes';
import { SelectChangeEvent } from '@mui/material';
import { schemaAddFiles } from '../schema';
import { useHistory, useLocation } from 'react-router-dom';
import { ECategory, ELabelReverse } from 'v2/resources/types/files';
import {
  useQueryAddFiles,
  useQueryPatchFiles,
} from 'v2/resources/hooks/services/files/useFiles';
import { IFileByGetResponse } from 'v2/resources/services/files/types';
import { useAppDispatch } from 'v2/resources/hooks/useAppSelector';
import { setToast } from 'v2/store/toast/slice';

//TODO: REFACTOR IN UPDATE REACT
const useAddFiles = () => {
  const ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'xlsx'];

  const navigate = useHistory();
  const route = useLocation();
  const dispatch = useAppDispatch();

  const fileEdit: IFileByGetResponse =
    (route.state as { file?: IFileByGetResponse })?.file ||
    ({} as IFileByGetResponse);

  const isEditing = !!fileEdit.id;

  const { isLoading: isLoadingAddFiles, mutateAsync: mutateAsyncAddFiles } =
    useQueryAddFiles();

  const { isLoading: isLoadingPatchFiles, mutateAsync: mutateAsyncPatchFiles } =
    useQueryPatchFiles();

  const joinExtensions = ALLOWED_EXTENSIONS.map(
    (ext) => `.${ext.toUpperCase()}`
  ).join(',');

  const jointExtensionsLower = joinExtensions.toLowerCase();

  const { isMobile } = useWindowSizes();

  const initialValues = fileEdit.id
    ? {
        file: null,
        description: fileEdit.description,
        title: fileEdit.title,
        category: ELabelReverse[fileEdit.category],
      }
    : {
        file: null,
        description: '',
        title: '',
        category: ECategory.SELECT_CATEGORY,
      };

  const handleSubmit = async (values: IFormikValues) => {
    if (isEditing) {
      await mutateAsyncPatchFiles({ id: fileEdit.id, payload: values });
      return;
    }

    if (!values.file) return;

    const formData = new FormData();

    formData.append('file', values.file);
    formData.append('title', values.title);
    formData.append('description', values.description);
    formData.append('category', values.category);

    await mutateAsyncAddFiles({ formData });
  };

  const formik = useFormik<IFormikValues>({
    initialValues,
    validationSchema: schemaAddFiles(isEditing),
    validateOnMount: true,
    onSubmit: handleSubmit,
  });

  const handleGoBack = () => {
    navigate.goBack();
  };

  const handleFormikChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target;

    formik.setFieldValue(name, value);
  };

  const handleOnChangeSelect = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;

    formik.setFieldValue('category', value);
  };

  const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const ext = file.name.split('.').pop()?.toLowerCase();
    if (!ext || !ALLOWED_EXTENSIONS.includes(ext)) {
      alert(`Formato inválido. Apenas ${joinExtensions} são permitidos.`);
      e.target.value = '';
      return;
    }

    formik.setFieldValue('file', file);
  };

  const handleRemoveFile = () => {
    formik.setFieldValue('file', null);
  };

  const handleDownloadDocument = () => {
    if (fileEdit.url) {
      window.open(fileEdit.url, '_blank');
      return;
    }
    dispatch(
      setToast({
        message: 'Nenhum arquivo para download',
        severity: 'error',
      })
    );
  };

  return {
    optionsCategories,
    formik,
    isMobile,
    jointExtensionsLower,
    joinExtensions,
    isLoadingAddFiles,
    isEditing,
    isLoadingPatchFiles,

    handleDownloadDocument,
    handleFileInput,
    handleRemoveFile,
    handleOnChangeSelect,
    handleFormikChange,
    handleGoBack,
  };
};

export default useAddFiles;
